import { mountClassic } from '../render/classic/classic-app.js';
import { makeSpiderClassicSpec } from '../variants/spider/classic-spec.js';
import type { SpiderSuitCount } from '../variants/spider/rules.js';

const root = document.getElementById('classic-stage');
if (!root) throw new Error('missing #classic-stage');

const raw = parseInt(root.dataset.suits ?? '4', 10);
const suits: SpiderSuitCount = raw === 1 ? 1 : raw === 2 ? 2 : 4;
mountClassic(makeSpiderClassicSpec({ suits }), {
  root,
  title: `Spider · ${suits} suit${suits === 1 ? '' : 's'}`,
});
